import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'shared/components/modal';

interface Props {
  email: string;
  onClose: () => void;
}

export default function InstitutionRequested(props: Props): React.ReactElement {
  return (
    <>
      <Modal.TextHeader onClose={props.onClose}>We&apos;re on it!</Modal.TextHeader>
      <Modal.Body>
        <p>
          We received your request and will send an email to <strong>{props.email}</strong> with
          more information about the status of your request within 1 business day.
        </p>
      </Modal.Body>
      <Modal.Footer
        primaryButton={{
          onClick: props.onClose,
          type: 'submit',
          'aria-label': 'done',
          text: 'Done',
          rightAligned: true,
        }}
      />
    </>
  );
}

InstitutionRequested.propTypes = {
  email: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
